import React, { useState, useEffect } from "react";
import Select from "react-dropdown-select";
import DatePicker from "react-datepicker";
import CONFIG_OBJECT from "../../../config/config";
import { postDataFetcher } from "../../../dataFetcher";
import configData from "../../../temp/config";
import { isMobile } from "react-device-detect";
import { Stepper } from "react-form-stepper";
import "bootstrap/dist/css/bootstrap.min.css";
import OutsideAlerter from "../outside-alerter/outsideAlerter";
import { registerLocale } from "react-datepicker";
import enIN from "date-fns/locale/en-IN";

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ListGroup from "react-bootstrap/ListGroup";

registerLocale("enIN", enIN);

let stepindex = 0;
let activeindex = 0;
let nextindex = 0;
let currentstep = {
  stepindex: 0,
  key: "",
  active: true,
  question: "",
  nextindex: 0,
  selectedvalue: "",
};
let steparry = [];

const OtherReminders = (props) => {
  let changeevent = false;
  let ReminderDate = "ReminderDate";
  let ReminderDuration = "ReminderDuration";
  let ReminderTime = "ReminderTime";
  const [enableSetReminder, setenableSetReminder] = useState(false);
  const [iconDictionary, setIconDictionary] = useState("");
  const [startoverclick, setstartoverclick] = useState(false);
  const [startoverenable, setstartoverenable] = useState(false);
  const [enablenext, setenablenext] = useState(false);
  const [isSetReminder, setisSetReminder] = useState(false);
  const [PillsStepper, setdivPillsStepper] = useState(false);
  const [InjectionStepper, setInjectionStepper] = useState(false);
  const [HygieneStepper, setdivHygieneStepper] = useState(false);
  const [divPillsDatePicker, setdivPillsDatePicker] = useState(true);
  const [divPillsDuration, setsetdivPillsDuration] = useState(false);
  const [divPillsRemainder, setsetdivPillsRemainder] = useState(false);
  const [divInjectionPicker, setdivInjectionPicker] = useState(true);
  const [divInjectionPickerRemainder, setdivInjectionPickerRemainder] =
    useState(false);

  const [toggleDatePicker, setToggleDatePicker] = useState(false);

  const [togglePillsDatePicker, setTogglePillsDatePicker] = useState(false);
  const [toggleInjectionDatePicker, setToggleInjectionDatePicker] =
    useState(false);
  const [toggleHygieneDatePicker, setToggleHygieneDatePicker] = useState(false);

  const [togglePillsDurationPicker, setTogglePillsDuration] = useState(false);
  const [toggleHygieneDurationPicker, setToggleHygieneDuration] =
    useState(false);

  const [togglePillsTimePicker, setTogglePillsTime] = useState(false);
  const [toggleInjectionTimePicker, setToggleInjectionTime] = useState(false);
  const [toggleHygieneTimePicker, setToggleHygieneTime] = useState(false);

  const [divHygieneDatePicker, setdivHygieneDatePicker] = useState(true);
  const [divHygieneDuration, setdivHygieneDuration] = useState(false);
  const [divHygieneRemainder, setdivHygieneRemainder] = useState(false);

  const [show, setShow] = useState(false);
  const [initialStepSelection, setInitialStepSelection] = useState(true);
  const [selectOpen, setSelectOpen] = useState(false);

  let pillsKey = "PILLS";
  let injectionsKey = "INJECTION";
  let hygieneKey = "HYGIENE";
  let initialValue = "NAN";

  const [pillsReminderDurationValue, setPillsReminderDurationValue] =
    useState(initialValue);
  const [pillsReminderTimeValue, setPillsReminderTimeValue] =
    useState(initialValue);
  const [pillsReminderDateValue, setPillsReminderDateValue] =
    useState(initialValue);

  const [injectionReminderTimeValue, setInjectionReminderTimeValue] =
    useState(initialValue);
  const [injectionReminderDateValue, setInjectionReminderDateValue] =
    useState(initialValue);

  const [hygieneReminderDurationValue, setHygieneReminderDurationValue] =
    useState(initialValue);
  const [hygieneReminderTimeValue, setHygieneReminderTimeValue] =
    useState(initialValue);
  const [hygieneReminderDateValue, setHygieneReminderDateValue] =
    useState(initialValue);

  const [disablePillsTrackNow, setDisablePillsTrackNow] = useState(true);

  const [disableInjectionsTrackNow, setDisableInjectionsTrackNow] =
    useState(true);
  const [disableHygieneTrackNow, setDisableHygieneTrackNow] = useState(true);

  const [reminderTime, setReminderTime] = useState([]);
  const [pillsDurationDropDownItems, setPillsDuration] = useState([]);
  const [pillsDurationDropDownDict, setPillsDurationDropDownDict] = useState(
    {}
  );
  const [hygieneDurationDropDownDict, setHygieneDurationDropDownDict] =
    useState({});

  const [hygieneProductsDuration, setHygieneProductsDuration] = useState([]);

  useEffect(() => {
    let iconsDictionary = {};
    if (props.iconList != null) {
      props.iconList.map((icon) => {
        let new_key = icon.fields["Icon Name"].value;
        let new_value =
          icon.fields.Image != null && icon.fields.Image.value != null
            ? icon.fields.Image.value.src
            : "";
        iconsDictionary[new_key] = new_value;
      });
      setIconDictionary(iconsDictionary);
    }
  }, []);

  useEffect(() => {
    if (props != null && props.durationDropDownItems != null) {
      let key = 0;
      props.durationDropDownItems.map((item, index) => {
        if (
          item.fields != null &&
          item.fields.name != null &&
          item.fields.key != null
        ) {
          if (props.reminderKey === pillsKey) {
            pillsDurationDropDownItems.push({
              value: key,
              label: item.fields.name.value,
            });
            pillsDurationDropDownDict[item.fields.name.value] =
              item.fields.key.value;
            setPillsDuration(pillsDurationDropDownItems);
          }

          if (props.reminderKey === hygieneKey) {
            hygieneProductsDuration.push({
              value: key,
              label: item.fields.name.value,
            });
            hygieneDurationDropDownDict[item.fields.name.value] =
              item.fields.key.value;
            setHygieneProductsDuration(hygieneProductsDuration);
          }
          key++;
        }
      });
    }

    var x = 15; //minutes interval
    var tt = 0; // start time 07:30 AM
    var ap = ["AM", "PM"]; // AM-PM

    for (var i = 0; i < (24 * 60) / x; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = tt % 60; // getting minutes of the hour in 0-55 format
      reminderTime[i] = {
        value: i,
        label:
          (hh % 12 === 0 ? "12" : "0" + (hh % 12)).slice(-2) +
          ":" +
          ("0" + mm).slice(-2) +
          " " +
          ap[Math.floor(hh >= 24 ? (hh - 24) / 12 : hh / 12)],
      };
      tt = tt + x;
    }
    setReminderTime(reminderTime);
  }, []);

  useEffect(() => {
    if (
      pillsReminderTimeValue != initialValue &&
      pillsReminderDurationValue != initialValue &&
      pillsReminderDateValue != initialValue
    ) {
      setDisablePillsTrackNow(false);
    }
  }, [
    pillsReminderDateValue,
    pillsReminderDurationValue,
    pillsReminderTimeValue,
  ]);

  useEffect(() => {
    if (
      hygieneReminderDateValue != initialValue &&
      hygieneReminderDurationValue != initialValue &&
      hygieneReminderTimeValue != initialValue
    ) {
      setDisableHygieneTrackNow(false);
    }
  }, [
    hygieneReminderDateValue,
    hygieneReminderDurationValue,
    hygieneReminderTimeValue,
  ]);

  useEffect(() => {
    if (
      injectionReminderDateValue != initialValue &&
      injectionReminderTimeValue != initialValue
    ) {
      setDisableInjectionsTrackNow(false);
    }
  }, [injectionReminderDateValue, injectionReminderTimeValue]);

  const PillsReminderDurationChange = (item) => {
    if (item != null && item[0] != null && item[0].label != null) {
      setPillsReminderDurationValue(item[0].label);
      setsetdivPillsDuration(false);
      setdivPillsDatePicker(false);
      setsetdivPillsRemainder(true);
    }
  };

  const HygieneProductsReminderDurationChange = (item) => {
    if (item != null && item[0] != null && item[0].label != null) {
      setHygieneReminderDurationValue(item[0].label);
      setdivHygieneDatePicker(false);
      setdivHygieneDuration(false);
      setdivHygieneRemainder(true);
    }
  };

  const PillsReminderTimeChange = (item) => {
    if (item != null && item[0] != null && item[0].label != null) {
      setPillsReminderTimeValue(item[0].label);
      setisSetReminder(true);
      setstartoverenable(true);
    }
  };

  const InjectionReminderTimeChange = (item) => {
    if (item != null && item[0] != null && item[0].label != null) {
      setInjectionReminderTimeValue(item[0].label);
      setisSetReminder(true);
      setdivPillsStepper(false);
      setstartoverenable(true);
    }
  };

  const HygieneReminderTimeChange = (item) => {
    if (item != null && item[0] != null && item[0].label != null) {
      setHygieneReminderTimeValue(item[0].label);
      setisSetReminder(true);
      setstartoverenable(true);
    }
  };

  const PillsReminderDateChange = (item) => {
    if (item != null) {
      setPillsReminderDateValue(item);
      setdivPillsStepper(false);
      setsetdivPillsDuration(true);
      setdivPillsDatePicker(false);
      setsetdivPillsRemainder(false);
      setdivInjectionPicker(false);
      setstartoverenable(true);
      if (isMobile) {
        setToggleDatePicker(false);
      } else {
        setTogglePillsDatePicker(false);
      }
    }
  };
  const InjectionReminderDateChange = (item) => {
    if (item != null) {
      setInjectionStepper(false);
      setInjectionReminderDateValue(item);
      setdivInjectionPicker(false);
      setdivInjectionPickerRemainder(true);
      setstartoverenable(true);
      if (isMobile) {
        setToggleDatePicker(false);
      } else {
        setToggleInjectionDatePicker(false);
      }
    }
  };

  const HygieneReminderDateChange = (item) => {
    if (item != null) {
      setstartoverenable(true);
      setdivPillsStepper(false);
      setInjectionStepper(false);
      setdivHygieneStepper(false);
      setHygieneReminderDateValue(item);
      setdivHygieneDatePicker(false);
      setdivHygieneDuration(true);
      setdivHygieneRemainder(false);
      if (isMobile) {
        setToggleDatePicker(false);
      } else {
        setToggleHygieneDatePicker(false);
      }
    }
  };

  const PillsSetReminders = () => {
    if (disablePillsTrackNow) {
      return;
    }
    let url = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.SET_REMINDERS_REST_URL}?sc_apikey=${configData.sitecoreApiKey}`;
    let EventStartDate = `${
      pillsReminderDateValue.getMonth() + 1
    }-${pillsReminderDateValue.getDate()}-${pillsReminderDateValue.getFullYear()}`;
    let cycleLength = pillsDurationDropDownDict[pillsReminderDurationValue];
    let NoofRecurrences = !isNaN(Number(props.NoofRecurrences.value))
      ? Number(props.NoofRecurrences.value)
      : 5;
    let data = {
      CalendarItemId: props.reminderId,
      EventStartDate: EventStartDate + " " + pillsReminderTimeValue,
      Interval: 1,
      NoOfRecurrences: cycleLength,
      ReminderKey: props.reminderKey,
    };
    postDataFetcher(url, data).then(
      (res) => {
        if (res.data.HasError) {
        } else {
          document.getElementById("pillsReminderForm").action =
            `${url}` +
            "&CalendarItemId=" +
            data.CalendarItemId +
            "&EventStartDate=" +
            data.EventStartDate +
            "&Interval=" +
            data.Interval +
            "&NoofRecurrences=" +
            data.NoOfRecurrences +
            "&ReminderKey=" +
            `${data.ReminderKey}`;
          document.getElementById("pillsReminderForm").submit();
          setDisablePillsTrackNow(true);
          document.getElementById("pillsReminderForm").action = "";
          setenableSetReminder(false);
        }
      },
      (err) => {}
    );
  };

  const InjectionsSetReminders = () => {
    if (disableInjectionsTrackNow) {
      return;
    }
    let url = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.SET_REMINDERS_REST_URL}?sc_apikey=${configData.sitecoreApiKey}`;
    let EventStartDate = `${
      injectionReminderDateValue.getMonth() + 1
    }-${injectionReminderDateValue.getDate()}-${injectionReminderDateValue.getFullYear()}`;
    let cycleLength = 1;

    let data = {
      CalendarItemId: props.reminderId,
      EventStartDate: EventStartDate + " " + injectionReminderTimeValue,
      Interval: cycleLength,
      NoOfRecurrences:
        props.NoofRecurrences.value != null && props.NoofRecurrences.value != ""
          ? props.NoofRecurrences.value
          : 5,
      ReminderKey: props.reminderKey,
    };

    postDataFetcher(url, data).then(
      (res) => {
        if (res.data.HasError) {
        } else {
          document.getElementById("injectionReminderForm").action =
            `${url}` +
            "&CalendarItemId=" +
            data.CalendarItemId +
            "&EventStartDate=" +
            data.EventStartDate +
            "&Interval=" +
            data.Interval +
            "&NoofRecurrences=" +
            data.NoOfRecurrences +
            "&ReminderKey=" +
            `${data.ReminderKey}`;
          document.getElementById("injectionReminderForm").submit();
          setDisableInjectionsTrackNow(true);
          setenableSetReminder(false);
          document.getElementById("injectionReminderForm").action = "";
        }
      },
      (err) => {}
    );
  };

  const HygieneProductsSetReminders = () => {
    if (disableHygieneTrackNow) {
      return;
    }
    let url = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.SET_REMINDERS_REST_URL}?sc_apikey=${configData.sitecoreApiKey}`;
    let EventStartDate = `${
      hygieneReminderDateValue.getMonth() + 1
    }-${hygieneReminderDateValue.getDate()}-${hygieneReminderDateValue.getFullYear()}`;
    let cycleLength = hygieneDurationDropDownDict[hygieneReminderDurationValue];
    let NoofRecurrences = 180;
    let time = hygieneReminderTimeValue.split(" ");
    let reminderTime =
      time[1] === "AM"
        ? `${time[0]}:00`
        : `${Number(time[0].split(":")[0]) + 12}:${time[0].split(":")[1]}:00`;
    let data = {
      CalendarItemId: props.reminderId,
      EventStartDate: EventStartDate + " " + reminderTime,
      Interval: cycleLength,
      NoOfRecurrences: NoofRecurrences,
      ReminderKey: props.reminderKey,
    };

    postDataFetcher(url, data).then(
      (res) => {
        if (res.data.HasError) {
        } else {
          document.getElementById("hygieneProductsReminderForm").action =
            `${url}` +
            "&CalendarItemId=" +
            data.CalendarItemId +
            "&EventStartDate=" +
            data.EventStartDate +
            "&Interval=" +
            data.Interval +
            "&NoofRecurrences=" +
            data.NoOfRecurrences +
            "&ReminderKey=" +
            `${data.ReminderKey}`;
          document.getElementById("hygieneProductsReminderForm").submit();
          setDisableHygieneTrackNow(true);
          setenableSetReminder(false);
          document.getElementById("hygieneProductsReminderForm").action = "";
        }
      },
      (err) => {}
    );
  };
  const StartOver = (event) => {
    event.preventDefault();
    props.startover(false);
    setShow(false); // hide popup
    setInitialStepSelection(true); // show initial selection
    props.hidethirddiv(false);
    setenablenext(false);
    setToggleDatePicker(false);
    setstartoverenable(false);
    setInjectionReminderTimeValue(initialValue);
    setInjectionReminderDateValue(initialValue);
    setPillsReminderDateValue(initialValue);
    setPillsReminderDurationValue(initialValue);
    setPillsReminderTimeValue(initialValue);
    setHygieneReminderDateValue(initialValue);
    setHygieneReminderDurationValue(initialValue);
    setHygieneReminderTimeValue(initialValue);
    document.getElementById(injectionsKey).style.display = "block";
    document.getElementById(hygieneKey).style.display = "block";
    document.getElementById(pillsKey).style.display = "block";
    setstartoverclick(true);
    setdivHygieneDatePicker(true);
    setdivHygieneDuration(false);
    setdivHygieneRemainder(false);
    setisSetReminder(false);
    setdivInjectionPicker(true);
    setdivInjectionPickerRemainder(false);
    setdivPillsDatePicker(true);
    setsetdivPillsDuration(false);
    setsetdivPillsRemainder(false);
    stepindex = 0;
    activeindex = 0;
    currentstep = {
      stepindex: 0,
      key: "",
      active: true,
      question: "",
    };
    steparry = [];
  };

  const Previous = (event, reminderkey, reminderquestion) => {
    // setToggleDatePicker(false);
    setisSetReminder(false);
    steparry.map((step) => {
      if (step["stepindex"] + 1 == event) {
        if (step["key"] == pillsKey) {
          if (step["question"] == ReminderDate) {
            // setToggleDatePicker(false);
            setdivPillsStepper(true);
            setdivPillsDatePicker(true);
            setsetdivPillsRemainder(false);
            setsetdivPillsDuration(false);
            setenablenext(true);
          } else if (step["question"] == ReminderDuration) {
            setdivPillsStepper(false);
            setdivPillsDatePicker(false);
            setsetdivPillsRemainder(false);
            setsetdivPillsDuration(true);
            setenablenext(true);
          }
        } else if (step["key"] == hygieneKey) {
          if (step["question"] == ReminderDate) {
            setdivHygieneStepper(true);
            setdivHygieneDatePicker(true);
            setdivHygieneDuration(false);
            setdivHygieneRemainder(false);
            setenablenext(true);
          }
          if (step["question"] == ReminderDuration) {
            setdivHygieneDatePicker(false);
            setdivHygieneDuration(true);
            setdivHygieneRemainder(false);
            setenablenext(true);
          }
        } else if (step["key"] == injectionsKey) {
          if (step["question"] == ReminderDate) {
            setInjectionStepper(true);
            setdivInjectionPicker(true);
            setdivInjectionPickerRemainder(false);
            setenablenext(true);
          } else if (step["question"] == ReminderDuration) {
            setInjectionStepper(true);
            setdivInjectionPicker(true);
            setdivInjectionPickerRemainder(false);
            setenablenext(true);
          }
        }
      }
    }, []);
    activeindex = activeindex - 1;
  };
  const Next = (event, reminderkey, reminderquestion) => {
    steparry.map((step) => {
      if (step["stepindex"] == event) {
        if (step["key"] == pillsKey) {
          if (step["question"] == ReminderDate) {
            setdivPillsStepper(false);
            setdivPillsDatePicker(false);
            setsetdivPillsRemainder(false);
            setsetdivPillsDuration(true);
            if (pillsReminderDurationValue == initialValue) {
              setenablenext(false);
            }
          } else if (step["question"] == ReminderDuration) {
            setdivPillsStepper(false);
            setdivPillsDatePicker(false);
            setsetdivPillsRemainder(true);
            setsetdivPillsDuration(false);
            setisSetReminder(true);
            if (pillsReminderTimeValue == initialValue) {
              setenablenext(false);
              setenableSetReminder(false);
            } else {
              setenableSetReminder(true);
            }
          }
        } else if (step["key"] == hygieneKey) {
          if (step["question"] == ReminderDate) {
            setdivHygieneStepper(false);
            setdivHygieneDatePicker(false);
            setdivHygieneDuration(true);
            setdivHygieneRemainder(false);
            if (hygieneReminderDurationValue == initialValue) {
              setenablenext(false);
            }
          }
          if (step["question"] == ReminderDuration) {
            setdivHygieneDatePicker(false);
            setdivHygieneDuration(false);
            setdivHygieneRemainder(true);
            setisSetReminder(true);
            if (hygieneReminderTimeValue == initialValue) {
              setenablenext(false);
              setenableSetReminder(false);
            } else {
              setenableSetReminder(true);
            }
          }
        } else if (step["key"] == injectionsKey) {
          if (step["question"] == ReminderDate) {
            setInjectionStepper(false);
            setdivInjectionPicker(false);
            setdivInjectionPickerRemainder(true);
            setisSetReminder(true);
            if (injectionReminderTimeValue == initialValue) {
              setenablenext(false);
              setenableSetReminder(false);
            } else {
              setenableSetReminder(true);
            }
          } else if (step["question"] == ReminderDuration) {
            setInjectionStepper(true);
            setdivInjectionPicker(true);
            setdivInjectionPickerRemainder(false);
          }
        }
      }
    }, []);
  };

  const onReminderDurationChange = (reminderKey, index, event) => {
    // debugger;
    if (event != null && event[0] != null && event[0].label != null) {
      changeevent = true;
      setenableSetReminder(false);
      setisSetReminder(true);
      if (reminderKey == pillsKey) {
        setPillsReminderDurationValue(event[0].label);
        setdivPillsStepper(false);
        setsetdivPillsDuration(false);
        setdivPillsDatePicker(false);
        setsetdivPillsRemainder(true);
        document.getElementById(injectionsKey).style.display = "none";
        document.getElementById(hygieneKey).style.display = "none";
      } else if ((reminderKey = hygieneKey)) {
        setHygieneReminderDurationValue(event[0].label);
        setdivHygieneDatePicker(false);
        setdivHygieneDuration(false);
        setdivHygieneRemainder(true);
      }
      let setvalue = true;
      steparry.map((step) => {
        if (step["question"] == ReminderDuration) {
          setvalue = false;
        }
      }, []);
      if (setvalue) {
        stepindex = index;
        nextindex = nextindex + 1;
        currentstep = {
          stepindex: index,
          key: reminderKey,
          active: true,
          question: ReminderDuration,
          nextindex: nextindex,
          selectedvalue: event[0].label,
        };
        steparry.push(currentstep);
      }
    }
  };
  const onReminderCalenderOpen = (reminderKey, index) => {
    setInitialStepSelection(false); // hide initial selection
    setShow(true); // display popup
    setToggleDatePicker(true);
    setstartoverclick(false);
    setstartoverenable(true);
    props.hidethirddiv(true);
    if (reminderKey == pillsKey) {
      setdivPillsStepper(true);
      document.getElementById(injectionsKey).style.display = "none";
      document.getElementById(hygieneKey).style.display = "none";
    } else if (reminderKey == injectionsKey) {
      setdivPillsStepper(false);
      setInjectionStepper(true);
      document.getElementById(pillsKey).style.display = "none";
      document.getElementById(hygieneKey).style.display = "none";
    } else if (reminderKey == hygieneKey) {
      setdivPillsStepper(false);
      setInjectionStepper(false);
      setdivHygieneStepper(true);
      document.getElementById(pillsKey).style.display = "none";
      document.getElementById(injectionsKey).style.display = "none";
    }
  };
  const onReminderDateChange = (reminderKey, index, event) => {
    if (event != null) {
      changeevent = true;
      if (reminderKey == pillsKey) {
        // debugger;
        setPillsReminderDateValue(event);
        setdivPillsStepper(false);
        setdivPillsDatePicker(false);
        setsetdivPillsDuration(true);
        setsetdivPillsRemainder(false);
        setdivInjectionPicker(false);
        setstartoverenable(true);
        document.getElementById(injectionsKey).style.display = "none";
        document.getElementById(hygieneKey).style.display = "none";
      } else if (reminderKey == injectionsKey) {
        setInjectionStepper(false);
        setdivPillsStepper(false);
        setInjectionReminderDateValue(event);
        setdivInjectionPicker(false);
        setdivInjectionPickerRemainder(true);
        setstartoverenable(true);
        setenableSetReminder(false);
        setisSetReminder(true);
      } else if (reminderKey == hygieneKey) {
        setstartoverenable(true);
        setdivPillsStepper(false);
        setInjectionStepper(false);
        setdivHygieneStepper(false);
        setHygieneReminderDateValue(event);
        setdivHygieneDatePicker(false);
        setdivHygieneDuration(true);
        setdivHygieneRemainder(false);
      }

      let setvalue = true;
      steparry.map((step) => {
        if (step["question"] == ReminderDate) {
          setvalue = false;
        }
      }, []);
      if (setvalue) {
        stepindex = index;
        nextindex = nextindex + 1;
        currentstep = {
          stepindex: index,
          key: reminderKey,
          active: true,
          question: ReminderDate,
          nextindex: nextindex,
          selectedvalue: event,
        };
        steparry.push(currentstep);
      }
      activeindex = activeindex + 1;
    }
  };
  const onReminderTimeChange = (reminderKey, index, event) => {
    if (event != null && event[0] != null && event[0].label != null) {
      changeevent = true;
      setenableSetReminder(true);
      if (reminderKey == pillsKey) {
        setPillsReminderTimeValue(event[0].label);
        setisSetReminder(true);
        setstartoverenable(true);
      } else if (reminderKey == injectionsKey) {
        setInjectionReminderTimeValue(event[0].label);
        setisSetReminder(true);
        setstartoverenable(true);
      } else if (reminderKey == hygieneKey) {
        setHygieneReminderTimeValue(event[0].label);
        setisSetReminder(true);
        setstartoverenable(true);
      }
      let setvalue = true;
      steparry.map((step) => {
        if (step["question"] == ReminderTime) {
          setvalue = false;
        }
      }, []);
      if (setvalue) {
        stepindex = index;
        nextindex = nextindex + 1;
        currentstep = {
          stepindex: index,
          key: reminderKey,
          active: true,
          question: ReminderDate,
          nextindex: nextindex,
          selectedvalue: event[0].label,
        };

        steparry.push(currentstep);
      }
      activeindex = activeindex + 1;
    }
  };

  const [isClickedOutSide, setIsClickedOutSide] = useState(false);

  useEffect(() => {
    if (isClickedOutSide) {
      setToggleDatePicker(false);
      setIsClickedOutSide(false);
    }
    if (isMobile) {
      let element = document.getElementById(pillsKey);
      element.click();
      setSelectOpen(true);
    }
  });
  const [showPreviousMonth, setShowPreviousMonth] = useState(false);
  const onMonthChange = (e) => {
    let monthChanged = new Date(e);
    let currentMonth = new Date();
    if (
      monthChanged.getMonth() === currentMonth.getMonth() &&
      showPreviousMonth
    ) {
      setShowPreviousMonth(false);
    } else if (
      monthChanged.getMonth() > currentMonth.getMonth() &&
      !showPreviousMonth
    ) {
      setShowPreviousMonth(true);
    }
  };
  return (
    <>
      {props != null && props.questionSet != null && (
        <>
          {!isMobile && (
            <OutsideAlerter
              className="row"
              setIsClickedOutSide={setIsClickedOutSide}
            >
              {props.questionSet.map((question, index) => {
                if (question.fields != null) {
                  return (
                    <>
                      <div
                        className={
                          index === 0
                            ? "col-sm col1 question-hover "
                            : "col-sm question-hover"
                        }
                      >
                        {question.fields.uniqueIdentifier != null && (
                          <a className="track-my-period-anchor">
                            <p className="input">
                              {" "}
                              {question.fields.QuestionLabel.value}
                              <span
                                className="fa fa-question-circle tool-tip-ques-icon help-tip help-tip-bottom"
                                tool-tip-toggle="tooltip-demo"
                              >
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderDate &&
                                  props.startDateSelectionTooltip != null &&
                                  props.startDateSelectionTooltip.value !=
                                    "" && (
                                    <p>
                                      {props.startDateSelectionTooltip.value}
                                    </p>
                                  )}
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderDuration &&
                                  props.durationSelectionToolTip != null &&
                                  props.durationSelectionToolTip.value !=
                                    "" && (
                                    <p>
                                      {props.durationSelectionToolTip.value}
                                    </p>
                                  )}
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderTime &&
                                  props.timeSelectionTooltip != null &&
                                  props.timeSelectionTooltip.value != "" && (
                                    <p>{props.timeSelectionTooltip.value}</p>
                                  )}
                              </span>
                            </p>
                            <span className="row">
                              <img
                                src={
                                  props.domain + question.fields.icon.value.src
                                }
                                className="reminders-input-images"
                                alt={question.fields.icon.value.alt}
                                width=""
                                onClick={() => {
                                  if (props.reminderKey === pillsKey) {
                                    setTogglePillsDatePicker((prev) => !prev);
                                    setToggleInjectionDatePicker(false);
                                    setToggleHygieneDatePicker(false);
                                  } else if (
                                    props.reminderKey === injectionsKey
                                  ) {
                                    setToggleInjectionDatePicker(
                                      (prev) => !prev
                                    );
                                    setTogglePillsDatePicker(false);
                                    setToggleHygieneDatePicker(false);
                                  } else if (props.reminderKey === hygieneKey) {
                                    setToggleHygieneDatePicker((prev) => !prev);
                                    setToggleInjectionDatePicker(false);
                                    setTogglePillsDatePicker(false);
                                  }
                                }}
                              />
                              {question.fields.uniqueIdentifier.value ===
                                ReminderDuration && (
                                <Select
                                  onDropdownOpen={() => {
                                    setToggleDatePicker(false);
                                  }}
                                  options={
                                    props.reminderKey === pillsKey
                                      ? pillsDurationDropDownItems
                                      : hygieneProductsDuration
                                  }
                                  onChange={
                                    props.reminderKey === pillsKey
                                      ? PillsReminderDurationChange
                                      : HygieneProductsReminderDurationChange
                                  }
                                  placeholder={
                                    question.fields["placeholder-text"].value
                                  }
                                  className="reminder-date-input"
                                />
                              )}
                              {question.fields.uniqueIdentifier.value ===
                                ReminderTime && (
                                <Select
                                  onDropdownOpen={() => {
                                    setToggleDatePicker(false);
                                  }}
                                  options={reminderTime}
                                  onChange={
                                    props.reminderKey === pillsKey
                                      ? PillsReminderTimeChange
                                      : props.reminderKey === injectionsKey
                                      ? InjectionReminderTimeChange
                                      : HygieneReminderTimeChange
                                  }
                                  value={
                                    props.reminderKey === pillsKey
                                      ? pillsReminderTimeValue != initialValue
                                        ? pillsReminderTimeValue
                                        : null
                                      : null
                                  }
                                  placeholder={
                                    question.fields["placeholder-text"].value
                                  }
                                  className="reminder-date-input"
                                />
                              )}
                              {question.fields.uniqueIdentifier.value ===
                                ReminderDate && (
                                <>
                                  <DatePicker
                                    dateFormat="dd MMMM, yyyy"
                                    monthsShown={2}
                                    onMonthChange={onMonthChange}
                                    showPreviousMonths={showPreviousMonth}
                                    locale="enIN"
                                    showPopperArrow={false}
                                    placeholderText={
                                      question.fields["placeholder-text"].value
                                    }
                                    minDate={new Date()}
                                    maxDate={
                                      new Date(
                                        new Date().getFullYear(),
                                        new Date().getMonth(),
                                        new Date().getDate() + 180
                                      )
                                    }
                                    onChange={
                                      props.reminderKey === pillsKey
                                        ? PillsReminderDateChange
                                        : props.reminderKey === injectionsKey
                                        ? InjectionReminderDateChange
                                        : HygieneReminderDateChange
                                    }
                                    open={
                                      props.reminderKey === pillsKey
                                        ? togglePillsDatePicker
                                        : props.reminderKey === injectionsKey
                                        ? toggleInjectionDatePicker
                                        : props.reminderKey === hygieneKey
                                        ? toggleHygieneDatePicker
                                        : false
                                    }
                                    onInputClick={() => {
                                      if (props.reminderKey === pillsKey) {
                                        setTogglePillsDatePicker(
                                          (prev) => !prev
                                        );
                                        setToggleInjectionDatePicker(false);
                                        setToggleHygieneDatePicker(false);
                                      } else if (
                                        props.reminderKey === injectionsKey
                                      ) {
                                        setToggleInjectionDatePicker(
                                          (prev) => !prev
                                        );
                                        setTogglePillsDatePicker(false);
                                        setToggleHygieneDatePicker(false);
                                      } else if (
                                        props.reminderKey === hygieneKey
                                      ) {
                                        setToggleHygieneDatePicker(
                                          (prev) => !prev
                                        );
                                        setToggleInjectionDatePicker(false);
                                        setTogglePillsDatePicker(false);
                                      }
                                    }}
                                    onClickOutside={() => {
                                      if (props.reminderKey === pillsKey) {
                                        setTogglePillsDatePicker(false);
                                        setToggleInjectionDatePicker(false);
                                        setToggleHygieneDatePicker(false);
                                      } else if (
                                        props.reminderKey === injectionsKey
                                      ) {
                                        setTogglePillsDatePicker(false);
                                        setToggleInjectionDatePicker(false);
                                        setToggleHygieneDatePicker(false);
                                      } else if (
                                        props.reminderKey === hygieneKey
                                      ) {
                                        setTogglePillsDatePicker(false);
                                        setToggleInjectionDatePicker(false);
                                        setToggleHygieneDatePicker(false);
                                      }
                                    }}
                                    selected={
                                      props.reminderKey === pillsKey
                                        ? pillsReminderDateValue != initialValue
                                          ? pillsReminderDateValue
                                          : null
                                        : props.reminderKey === injectionsKey
                                        ? injectionReminderDateValue !=
                                          initialValue
                                          ? injectionReminderDateValue
                                          : null
                                        : hygieneReminderDateValue !=
                                          initialValue
                                        ? hygieneReminderDateValue
                                        : null
                                    }
                                  />
                                </>
                              )}
                            </span>
                          </a>
                        )}
                      </div>
                    </>
                  );
                }
              })}

              {
                <form
                  method="post"
                  id={
                    props.reminderKey === pillsKey
                      ? "pillsReminderForm"
                      : props.reminderKey === injectionsKey
                      ? "injectionReminderForm"
                      : "hygieneProductsReminderForm"
                  }
                >
                  <div className="col-sm col4">
                    <a
                      className={
                        props.reminderKey === pillsKey
                          ? disablePillsTrackNow
                            ? "tracknow"
                            : "tracknow-enabled"
                          : props.reminderKey === injectionsKey
                          ? disableInjectionsTrackNow
                            ? "tracknow"
                            : "tracknow-enabled"
                          : disableHygieneTrackNow
                          ? "tracknow"
                          : "tracknow-enabled"
                      }
                      disabled={
                        props.reminderKey === pillsKey
                          ? disablePillsTrackNow
                          : props.reminderKey === injectionsKey
                          ? disableInjectionsTrackNow
                          : disableHygieneTrackNow
                      }
                      onClick={
                        props.reminderKey === pillsKey
                          ? PillsSetReminders
                          : props.reminderKey === injectionsKey
                          ? InjectionsSetReminders
                          : HygieneProductsSetReminders
                      }
                    >
                      {props.submitLabel}
                    </a>
                  </div>
                </form>
              }
            </OutsideAlerter>
          )}

          {isMobile && (
            <>
              {initialStepSelection && (
                <>
                  {props.questionSet.map((question, index) => {
                    if (question.fields != null && index === 0) {
                      return (
                        <div className="col-sm col1 question-hover div-other-reminders-mob text-center">
                          {question.fields.uniqueIdentifier != null && (
                            <a className="track-my-period-anchor other-reminders">
                              <p className="input">
                                {" "}
                                {question.fields.QuestionLabel.value}
                                <span
                                  className="fa fa-question-circle tool-tip-ques-icon help-tip help-tip-bottom"
                                  tool-tip-toggle="tooltip-demo"
                                >
                                  {question.fields.uniqueIdentifier.value ===
                                    ReminderDate &&
                                    props.startDateSelectionTooltip != null &&
                                    props.startDateSelectionTooltip.value !=
                                      "" && (
                                      <p>
                                        {props.startDateSelectionTooltip.value}
                                      </p>
                                    )}
                                  {question.fields.uniqueIdentifier.value ===
                                    ReminderDuration &&
                                    props.durationSelectionToolTip != null &&
                                    props.durationSelectionToolTip.value !=
                                      "" && (
                                      <p>
                                        {props.durationSelectionToolTip.value}
                                      </p>
                                    )}
                                  {question.fields.uniqueIdentifier.value ===
                                    ReminderTime &&
                                    props.timeSelectionTooltip != null &&
                                    props.timeSelectionTooltip.value != "" && (
                                      <p>{props.timeSelectionTooltip.value}</p>
                                    )}
                                </span>
                              </p>
                              <span
                                className="row justify-content-center"
                                style={{ marginLeft: "84px" }}
                              >
                                <img
                                  src={
                                    props.domain +
                                    question.fields.icon.value.src
                                  }
                                  className="reminders-input-images"
                                  alt={question.fields.icon.value.alt}
                                  width=""
                                  onClick={() => {
                                    if (
                                      question.fields.uniqueIdentifier.value ===
                                      ReminderDate
                                    )
                                      onReminderCalenderOpen(
                                        props.reminderKey,
                                        index
                                      );
                                  }}
                                />
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderDate && (
                                  <DatePicker
                                    onCalendarOpen={onReminderCalenderOpen.bind(
                                      null,
                                      props.reminderKey,
                                      index
                                    )}
                                    locale="enIN"
                                    dateFormat="dd MMMM, yyyy"
                                    monthsShown={1}
                                    endDate={Date.now}
                                    showPopperArrow={false}
                                    placeholderText={
                                      question.fields["placeholder-text"].value
                                    }
                                    minDate={new Date()}
                                    maxDate={
                                      new Date(
                                        new Date().getFullYear(),
                                        new Date().getMonth(),
                                        new Date().getDate() + 180
                                      )
                                    }
                                    open={toggleDatePicker}
                                    onChange={onReminderDateChange.bind(
                                      null,
                                      props.reminderKey,
                                      index
                                    )}
                                    selected={
                                      props.reminderKey === pillsKey
                                        ? pillsReminderDateValue != initialValue
                                          ? pillsReminderDateValue
                                          : null
                                        : props.reminderKey === injectionsKey
                                        ? injectionReminderDateValue !=
                                          initialValue
                                          ? injectionReminderDateValue
                                          : null
                                        : hygieneReminderDateValue !=
                                          initialValue
                                        ? hygieneReminderDateValue
                                        : null
                                    }
                                    onClickOutside={() =>
                                      setToggleDatePicker(false)
                                    }
                                  />
                                )}
                              </span>
                            </a>
                          )}
                        </div>
                      );
                    }
                  })}
                </>
              )}

              {/* Niket's chnages starts here */}
              <Modal
                className="modal-mobile-period-calc"
                show={show}
                animation={false}
              >
                <ModalBody>
                  {props.questionSet.map((question, index) => {
                    if (question.fields != null) {
                      return (
                        <>
                          <div // stepper heading
                            className={
                              question.fields.uniqueIdentifier.value ===
                              ReminderDate
                                ? props.reminderKey === pillsKey
                                  ? PillsStepper
                                    ? "stepper-heading"
                                    : "d-none"
                                  : props.reminderKey === injectionsKey
                                  ? InjectionStepper
                                    ? "stepper-heading"
                                    : "d-none"
                                  : HygieneStepper
                                  ? "stepper-heading"
                                  : "d-none"
                                : question.fields.uniqueIdentifier.value ===
                                  ReminderDuration
                                ? props.reminderKey === pillsKey
                                  ? divPillsDuration
                                    ? "stepper-heading"
                                    : "d-none"
                                  : divHygieneDuration
                                  ? "stepper-heading"
                                  : "d-none"
                                : props.reminderKey === pillsKey
                                ? divPillsRemainder
                                  ? "stepper-heading"
                                  : "d-none"
                                : props.reminderKey === injectionsKey
                                ? divInjectionPickerRemainder
                                  ? "stepper-heading"
                                  : "d-none"
                                : divHygieneRemainder
                                ? "stepper-heading"
                                : "d-none"
                            }
                          >
                            {!startoverclick && ( // stepper close
                              <a
                                onClick={StartOver}
                                className={
                                  question.fields.uniqueIdentifier.value ===
                                  ReminderDate
                                    ? props.reminderKey === pillsKey
                                      ? PillsStepper
                                        ? "other-reminder-close"
                                        : "d-none"
                                      : props.reminderKey === injectionsKey
                                      ? InjectionStepper
                                        ? "other-reminder-close"
                                        : "d-none"
                                      : HygieneStepper
                                      ? "other-reminder-close"
                                      : "d-none"
                                    : question.fields.uniqueIdentifier.value ===
                                      ReminderDuration
                                    ? props.reminderKey === pillsKey
                                      ? divPillsDuration
                                        ? "other-reminder-close"
                                        : "d-none"
                                      : divHygieneDuration
                                      ? "other-reminder-close"
                                      : "d-none"
                                    : props.reminderKey === pillsKey
                                    ? divPillsRemainder
                                      ? "other-reminder-close"
                                      : "d-none"
                                    : props.reminderKey === injectionsKey
                                    ? divInjectionPickerRemainder
                                      ? "other-reminder-close"
                                      : "d-none"
                                    : divHygieneRemainder
                                    ? "other-reminder-close"
                                    : "d-none"
                                }
                              >
                                <span className="fa fa-times"></span>
                              </a>
                            )}
                            {question.fields.QuestionLabel.value}
                          </div>

                          {!startoverclick && (
                            <Stepper
                              id={
                                question.fields.uniqueIdentifier.value ===
                                ReminderDate
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDatePicker
                                      ? "pillsDate"
                                      : ""
                                    : props.reminderKey === injectionsKey
                                    ? divInjectionPicker
                                      ? "injectionDate"
                                      : ""
                                    : divHygieneDatePicker
                                    ? "hygieneDate"
                                    : ""
                                  : question.fields.uniqueIdentifier.value ===
                                    ReminderDuration
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDuration
                                      ? "pillsDuration"
                                      : ""
                                    : divHygieneDuration
                                    ? "hygieneDuration"
                                    : ""
                                  : props.reminderKey === pillsKey
                                  ? divPillsRemainder
                                    ? "pillsReminder"
                                    : ""
                                  : props.reminderKey === injectionsKey
                                  ? divInjectionPickerRemainder
                                    ? "injectionReminder"
                                    : ""
                                  : divHygieneRemainder
                                  ? "hygieneReminder"
                                  : ""
                              }
                              className={
                                question.fields.uniqueIdentifier.value ===
                                ReminderDate
                                  ? props.reminderKey === pillsKey
                                    ? PillsStepper
                                      ? "RFS-StepperContainer"
                                      : "d-none"
                                    : props.reminderKey === injectionsKey
                                    ? InjectionStepper
                                      ? "RFS-StepperContainer"
                                      : "d-none"
                                    : HygieneStepper
                                    ? "RFS-StepperContainer"
                                    : "d-none"
                                  : question.fields.uniqueIdentifier.value ===
                                    ReminderDuration
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDuration
                                      ? "RFS-StepperContainer"
                                      : "d-none"
                                    : divHygieneDuration
                                    ? "RFS-StepperContainer"
                                    : "d-none"
                                  : props.reminderKey === pillsKey
                                  ? divPillsRemainder
                                    ? "RFS-StepperContainer"
                                    : "d-none"
                                  : props.reminderKey === injectionsKey
                                  ? divInjectionPickerRemainder
                                    ? "RFS-StepperContainer"
                                    : "d-none"
                                  : divHygieneRemainder
                                  ? "RFS-StepperContainer"
                                  : "d-none"
                              }
                              steps={
                                props.reminderKey != injectionsKey
                                  ? [
                                      {
                                        href: "",
                                        onClick: (e) => {
                                          e.preventDefault();
                                        },
                                      },
                                      {
                                        href: "",
                                        onClick: (e) => {
                                          e.preventDefault();
                                        },
                                      },
                                      { label: "" },
                                    ]
                                  : [
                                      {
                                        href: "",
                                        onClick: (e) => {
                                          e.preventDefault();
                                        },
                                      },
                                      { label: "" },
                                    ]
                              }
                              activeStep={
                                question.fields.uniqueIdentifier.value ===
                                ReminderDate
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDatePicker
                                      ? 0
                                      : 0
                                    : props.reminderKey === injectionsKey
                                    ? divInjectionPicker
                                      ? 0
                                      : 0
                                    : divHygieneDatePicker
                                    ? 0
                                    : 0
                                  : question.fields.uniqueIdentifier.value ===
                                    ReminderDuration
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDuration
                                      ? 1
                                      : 0
                                    : divHygieneDuration
                                    ? 1
                                    : 0
                                  : question.fields.uniqueIdentifier.value ===
                                    ReminderTime
                                  ? props.reminderKey === pillsKey
                                    ? divPillsRemainder
                                      ? 2
                                      : 0
                                    : props.reminderKey === injectionsKey
                                    ? divInjectionPickerRemainder
                                      ? 2
                                      : 0
                                    : divHygieneRemainder
                                    ? 2
                                    : 2
                                  : 0
                              }
                            />
                          )}
                          <div
                            className={
                              question.fields.uniqueIdentifier.value ===
                              ReminderDate
                                ? props.reminderKey === pillsKey
                                  ? divPillsDatePicker
                                    ? "col-sm col1 div-other-reminders-mob"
                                    : "d-none"
                                  : props.reminderKey === injectionsKey
                                  ? divInjectionPicker
                                    ? "col-sm col1 div-other-reminders-mob"
                                    : "d-none"
                                  : divHygieneDatePicker
                                  ? "col-sm col1 div-other-reminders-mob"
                                  : "d-none"
                                : question.fields.uniqueIdentifier.value ===
                                  ReminderDuration
                                ? props.reminderKey === pillsKey
                                  ? divPillsDuration
                                    ? "col-sm col1 question-hover div-other-reminders-mob mx-3"
                                    : "d-none"
                                  : divHygieneDuration
                                  ? "col-sm col1 question-hover div-other-reminders-mob mx-3"
                                  : "d-none"
                                : props.reminderKey === pillsKey
                                ? divPillsRemainder
                                  ? "col-sm col1 question-hover div-other-reminders-mob mx-3"
                                  : "d-none"
                                : props.reminderKey === injectionsKey
                                ? divInjectionPickerRemainder
                                  ? "col-sm col1 question-hover div-other-reminders-mob mx-3"
                                  : "d-none"
                                : divHygieneRemainder
                                ? "col-sm col1 question-hover div-other-reminders-mob mx-3"
                                : "d-none"
                            }
                          >
                            {question.fields.uniqueIdentifier != null && (
                              <>
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderDate && (
                                  <div className="fourth-div-reminders-tab other-reminders-mobile">
                                    <a className="track-my-period-anchor other-reminders">
                                      <div className="datepicker-dialog">
                                        <DatePicker
                                          onCalendarOpen={onReminderCalenderOpen.bind(
                                            null,
                                            props.reminderKey,
                                            index
                                          )}
                                          locale="enIN"
                                          dateFormat="dd MMMM, yyyy"
                                          monthsShown={1}
                                          endDate={Date.now}
                                          showPopperArrow={false}
                                          placeholderText={
                                            question.fields["placeholder-text"]
                                              .value
                                          }
                                          minDate={new Date()}
                                          maxDate={
                                            new Date(
                                              new Date().getFullYear(),
                                              new Date().getMonth(),
                                              new Date().getDate() + 180
                                            )
                                          }
                                          open={toggleDatePicker}
                                          onChange={onReminderDateChange.bind(
                                            null,
                                            props.reminderKey,
                                            index
                                          )}
                                          selected={
                                            props.reminderKey === pillsKey
                                              ? pillsReminderDateValue !=
                                                initialValue
                                                ? pillsReminderDateValue
                                                : null
                                              : props.reminderKey ===
                                                injectionsKey
                                              ? injectionReminderDateValue !=
                                                initialValue
                                                ? injectionReminderDateValue
                                                : null
                                              : hygieneReminderDateValue !=
                                                initialValue
                                              ? hygieneReminderDateValue
                                              : null
                                          }
                                        />
                                      </div>
                                    </a>
                                  </div>
                                )}
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderDuration &&
                                  startoverenable && (
                                    <a className="track-my-period-anchor other-reminders">
                                      <span className="row">
                                        {question.fields.uniqueIdentifier
                                          .value === ReminderDuration &&
                                          startoverenable && (
                                            <Select
                                              options={
                                                props.reminderKey === pillsKey
                                                  ? pillsDurationDropDownItems
                                                  : hygieneProductsDuration
                                              }
                                              onChange={onReminderDurationChange.bind(
                                                null,
                                                props.reminderKey,
                                                index
                                              )}
                                              dropdownHandle={selectOpen}
                                              keepOpen={selectOpen}
                                              autoFocus={selectOpen}
                                              placeholder={
                                                question.fields[
                                                  "placeholder-text"
                                                ].value
                                              }
                                              className="reminder-date-input"
                                              id="select-1"
                                            />
                                          )}
                                      </span>
                                    </a>
                                  )}
                                {question.fields.uniqueIdentifier.value ===
                                  ReminderTime &&
                                  startoverenable && (
                                    <a className="track-my-period-anchor other-reminders">
                                      <span className="row">
                                        {question.fields.uniqueIdentifier
                                          .value === ReminderTime &&
                                          startoverenable && (
                                            <Select
                                              dropdownHandle={selectOpen}
                                              keepOpen={selectOpen}
                                              autoFocus={selectOpen}
                                              options={reminderTime}
                                              onChange={onReminderTimeChange.bind(
                                                null,
                                                props.reminderKey,
                                                index
                                              )}
                                              placeholder={
                                                question.fields[
                                                  "placeholder-text"
                                                ].value
                                              }
                                              className="reminder-date-input"
                                              id="select-2"
                                            />
                                          )}
                                      </span>
                                    </a>
                                  )}
                              </>
                            )}
                          </div>
                          {isMobile && startoverenable && (
                            <div
                              className={
                                index <= 1 &&
                                question.fields.uniqueIdentifier.value ===
                                  ReminderDate
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDatePicker
                                      ? "row stepper-footer"
                                      : "d-none"
                                    : props.reminderKey === injectionsKey
                                    ? divInjectionPicker
                                      ? "row stepper-footer"
                                      : "d-none"
                                    : divHygieneDatePicker
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : question.fields.uniqueIdentifier.value ===
                                    ReminderDuration
                                  ? props.reminderKey === pillsKey
                                    ? divPillsDuration
                                      ? "row stepper-footer"
                                      : "d-none"
                                    : divHygieneDuration
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : props.reminderKey === pillsKey
                                  ? divPillsRemainder
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : props.reminderKey === injectionsKey
                                  ? divInjectionPickerRemainder
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : divHygieneRemainder
                                  ? "row stepper-footer"
                                  : "d-none"
                              }
                              id={`${index}_startover`}
                            >
                              <div className="col-6">
                                <div
                                  className={
                                    index > 0 ? "" : "disable-prev d-none"
                                  }
                                >
                                  <a
                                    className={
                                      startoverenable
                                        ? "next-other-reminder prev-other-reminder"
                                        : "d-none"
                                    }
                                    onClick={Previous.bind(
                                      null,
                                      index,
                                      props.reminderKey,
                                      question.fields.uniqueIdentifier.value
                                    )}
                                  >
                                    <i className=" fa fa-arrow-left"></i>
                                    Previous
                                  </a>
                                </div>
                              </div>
                              <div className="col-6">
                                <a
                                  className={
                                    !isSetReminder
                                      ? enablenext
                                        ? "next-other-reminder tracknow-enabled"
                                        : "next-other-reminder tracknow"
                                      : "d-none"
                                  }
                                  onClick={Next.bind(
                                    null,
                                    index,
                                    props.reminderKey,
                                    question.fields.uniqueIdentifier.value
                                  )}
                                >
                                  Next
                                </a>
                                {
                                  <form
                                    method="post"
                                    id={
                                      props.reminderKey === pillsKey
                                        ? "pillsReminderForm"
                                        : props.reminderKey === injectionsKey
                                        ? "injectionReminderForm"
                                        : "hygieneProductsReminderForm"
                                    }
                                  >
                                    <a
                                      className={
                                        isSetReminder
                                          ? enableSetReminder
                                            ? "remindes-tracknow-enabled"
                                            : "remindes-tracknow-disabled"
                                          : "d-none"
                                      }
                                      disabled={
                                        props.reminderKey === pillsKey
                                          ? disablePillsTrackNow
                                          : props.reminderKey === injectionsKey
                                          ? disableInjectionsTrackNow
                                          : disableHygieneTrackNow
                                      }
                                      onClick={
                                        props.reminderKey === pillsKey
                                          ? PillsSetReminders
                                          : props.reminderKey === injectionsKey
                                          ? InjectionsSetReminders
                                          : HygieneProductsSetReminders
                                      }
                                    >
                                      {props.submitLabel}
                                    </a>
                                  </form>
                                }
                              </div>
                            </div>
                          )}
                        </>
                      );
                    }
                  })}
                </ModalBody>
              </Modal>
              {/* Niket's chnages ends here */}
            </>
          )}
        </>
      )}
    </>
  );
};

export default OtherReminders;
